import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Ticket, User } from 'src/app/models';
import { RequirementsTabComponent } from './tabs/requirements-tab/requirements-tab.component';
import { RevisionsTabComponent } from './tabs/revisions-tab/revisions-tab.component';

@Component({
  selector: 'ts-dev-tab',
  templateUrl: './ts-dev-tab.component.html',
  styleUrls: ['./ts-dev-tab.component.scss'],
  standalone: false,
})
export class TsDevTabComponent implements OnInit {
  @Input() unconfirmedTicket?: Ticket;
  @Input() user?: User;

  @ViewChild(RequirementsTabComponent) requirementsTabComponent?: RequirementsTabComponent;
  @ViewChild(RevisionsTabComponent) revisionsTabComponent?: RevisionsTabComponent;

  tabIds = ['requirements-tab', 'revisions-tab'];
  activeTab: string = this.tabIds[0];

  constructor() {}

  ngOnInit(): void {}

  isFormValid() {
    return true;
    //return this.form.form.status === 'VALID';
  }

  loadTabDev() {
    this.revisionsTabComponent?.loadTicketRevision();
    this.requirementsTabComponent?.loadTicketRequirements();
  }
}
